export default __webpack_public_path__ + "static/Cart-Filters-9249315b4856cf4a0588e36d0d0bef67.webp";